import { useWatch } from "react-hook-form";

import { FieldDescription } from "@/components/ui/field";
import { FormInput } from "components/BaseForm";
import { DEFAULT_COST_SUFFIX } from "routes/product/pricing/pricing";

const DefaultCostField = () => {
  const priceBasis = useWatch({ name: "price_basis" });

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <FormInput
        name="default_cost"
        label="Default Cost"
        inputMode="decimal"
        prefix="$"
        suffix={DEFAULT_COST_SUFFIX[priceBasis]}
        aria-describedby="default_cost_help"
      />
      <FieldDescription id="default_cost_help">
        What we pay for 1 unit of this license. Pre-fills Cost when this product
        is selected on an invoice line. Changing it never updates existing
        lines.
      </FieldDescription>
    </div>
  );
};

export default DefaultCostField;
